import { render, staticRenderFns } from "./war-cemetry.vue?vue&type=template&id=30d071c0&scoped=true&"
import script from "./war-cemetry.vue?vue&type=script&lang=js&"
export * from "./war-cemetry.vue?vue&type=script&lang=js&"
import style0 from "./war-cemetry.vue?vue&type=style&index=0&id=30d071c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d071c0",
  null
  
)

export default component.exports